import moment from 'moment';
import {useLayoutEffect, useRef, useMemo} from 'react';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';

import {RootState} from '../../../../../index';
import {getRewardsTop10GamesState} from '../../../../../selectors/fortnite-game/rewardsTop10GamesSelector';
import {RewardsTop10GamesState} from '../../../../../reducers/fortnite-game/rewardsTop10Games.reducer';
import rewardsTop10GamesActions from '../../../../../actions/fortnite-game/rewardsTop10Games.actions';
import {monthlyEndDate} from '../../../../global-date-picker';
import {DATE_NOW} from '../constants';

const START_DATE = moment(DATE_NOW)
    .subtract(2, 'months')
    .startOf('month');
const END_DATE = monthlyEndDate(DATE_NOW);

export interface UseRewardsState extends RewardsTop10GamesState {
    reload: () => void;
}

const useRewardsTop10GamesData = (): UseRewardsState => {
    const dispatch = useDispatch();
    const intervalRef = useRef(null);

    const {data, loading, error} = useSelector<RootState, RewardsTop10GamesState>(
        getRewardsTop10GamesState,
        shallowEqual
    );

    const formattedData = useMemo(() => {
        const engagementPayouts = data.map(({islandCode, lastMonthPayout, prevMonthPayout}) => {
            const prev = Number(prevMonthPayout);
            const last = Number(lastMonthPayout);
            const difference = prev ? prev - last : 0;
            const trend = Math.round(prev ? (difference / prev) * 100 : 0);

            return {islandCode, value: lastMonthPayout, trend};
        });

        return engagementPayouts;
    }, [data]);

    const queryParams = {
        fromTs: START_DATE.valueOf(),
        toTs: END_DATE.valueOf()
    };

    const fetchData = () => {
        dispatch(rewardsTop10GamesActions.getRewardsTop10Games(queryParams));
    };

    useLayoutEffect(() => {
        fetchData();

        return () => {
            clearInterval(intervalRef.current);
        };
    }, []);

    return {
        data: formattedData,
        loading,
        error,
        reload: fetchData
    };
};

export default useRewardsTop10GamesData;
